import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Obligations} from '../model/eligibility-check/eligibility-check-request.model';
import {CreditAssessmentInfoResolver} from '../borrow/eligibility-check/credit-assessment-info.resolver';

@Injectable()
export class ObligationsResolver implements Resolve<Obligations> {
    constructor(private creditAssessmentResolver: CreditAssessmentInfoResolver) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Obligations> {
        const creditAssessment = await this.creditAssessmentResolver.resolve(route, state);

        if (creditAssessment) {
            return creditAssessment.obligations;
        }

        const locallySavedEligibilityCheck = this.creditAssessmentResolver.getLocallySavedEligibilityCheck();
        return locallySavedEligibilityCheck ? Obligations.from(locallySavedEligibilityCheck.obligations) : undefined;
    }
}
